import { Info } from 'lucide-preact'
import { useWorkspaceCapabilities } from '@/hooks/useWorkspaceCapabilities'

/**
 * The Details tab's note on a signed-off web. `locked` names what can't change until the web is reopened. Only
 * editors see it: Reopen is theirs, and everyone else already has the header's Signed Off badge.
 */
export function SignedOffNote({ locked, stillAllowed }: { locked: string; stillAllowed?: string }) {
  const { canEdit } = useWorkspaceCapabilities()
  if (!canEdit) return null

  return (
    <div className="rounded-lg border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 p-3 flex items-center gap-3 text-sm text-blue-800 dark:text-blue-300 mb-6">
      <Info className="w-5 h-5 flex-shrink-0" />
      <span>This web is signed off. Reopen from the header above to make changes to {locked}.{stillAllowed && ` ${stillAllowed}`}</span>
    </div>
  )
}
